import * as React from 'react'

export const RussiaFlag = () => {
  return (
    <svg width="56" height="40" viewBox="0 0 56 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" y="0.5" width="55" height="39" rx="3.5" fill="white" stroke="#F5F5F5" />
      <mask
        id="mask0_103_1362"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="56"
        height="40"
      >
        <rect x="0.5" y="0.5" width="55" height="39" rx="3.5" fill="white" stroke="white" />
      </mask>
      <g mask="url(#mask0_103_1362)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 26.6666H56V13.3333H0V26.6666Z"
          fill="#0C47B7"
        />
        <path fillRule="evenodd" clipRule="evenodd" d="M0 40H56V26.6667H0V40Z" fill="#E53B35" />
      </g>
    </svg>
  )
}

export const BangladeshFlag = () => {
  return (
    <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect y="8" width="56" height="40" rx="4" fill="white" />
      <mask
        id="mask0_17_3110"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="8"
        width="56"
        height="40"
      >
        <rect y="8" width="56" height="40" rx="4" fill="white" />
      </mask>
      <g mask="url(#mask0_17_3110)">
        <rect y="8" width="56" height="40" fill="#128363" />
        <circle cx="25.3333" cy="28" r="12" fill="#F23C53" />
      </g>
    </svg>
  )
}

export const ChinaFlag = () => {
  return (
    <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect y="8" width="56" height="40" rx="4" fill="white" />
      <mask
        id="mask0_17_3029"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="8"
        width="56"
        height="40"
      >
        <rect y="8" width="56" height="40" rx="4" fill="white" />
      </mask>
      <g mask="url(#mask0_17_3029)">
        <rect y="8" width="56" height="40" fill="#F1361D" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.1453 14.2015L22.0822 14.5317L23.5348 15.8547L23.8651 13.9178L25.188 12.4651L23.2512 12.1349L21.7985 10.8119L21.4683 12.7488L20.1453 14.2015ZM25.3333 20.976L27.0118 19.9545L28.9761 19.9999L27.9546 18.3215L28 16.3572L26.3216 17.3787L24.3573 17.3333L25.3788 19.0117L25.3333 20.976ZM23.0565 31.9417L21.4147 33.0211L21.3916 31.0564L20.3121 29.4147L22.2768 29.3915L23.9186 28.3121L23.9417 30.2768L25.0212 31.9185L23.0565 31.9417ZM24.4823 26.8628L26.4351 26.6463L28.1962 27.5177L27.9797 25.5648L28.8511 23.8037L26.8982 24.0202L25.1371 23.1489L25.3536 25.1017L24.4823 26.8628Z"
          fill="#FFDC42"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.3333 24.4534L8.63105 27.8055L10.366 22.2975L5.72488 18.8612L11.4994 18.8092L13.3333 13.3334L15.1672 18.8092L20.9418 18.8612L16.3006 22.2975L18.0356 27.8055L13.3333 24.4534Z"
          fill="#FFDC42"
        />
      </g>
    </svg>
  )
}

export const FranceFlag = () => {
  return (
    <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" y="8.5" width="55" height="39" rx="3.5" fill="white" stroke="#F5F5F5" />
      <mask
        id="mask0_17_2942"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="8"
        width="56"
        height="40"
      >
        <rect x="0.5" y="8.5" width="55" height="39" rx="3.5" fill="white" stroke="white" />
      </mask>
      <g mask="url(#mask0_17_2942)">
        <rect x="37.3333" y="8" width="18.6667" height="40" fill="#F44653" />
        <path fillRule="evenodd" clipRule="evenodd" d="M0 48H18.6667V8H0V48Z" fill="#1035BB" />
      </g>
    </svg>
  )
}

export const GermanyFlag = () => {
  return (
    <svg width="56" height="40" viewBox="0 0 56 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="56" height="40" rx="4" fill="white" />
      <mask
        id="mask0_103_2117"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="56"
        height="40"
      >
        <rect width="56" height="40" rx="4" fill="white" />
      </mask>
      <g mask="url(#mask0_103_2117)">
        <path fillRule="evenodd" clipRule="evenodd" d="M0 13.3333H56V0H0V13.3333Z" fill="#262626" />
        <g filter="url(#filter0_d_103_2117)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 26.6667H56V13.3333H0V26.6667Z"
            fill="#F01515"
          />
        </g>
        <g filter="url(#filter1_d_103_2117)">
          <path fillRule="evenodd" clipRule="evenodd" d="M0 40H56V26.6667H0V40Z" fill="#FFD521" />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_d_103_2117"
          x="0"
          y="13.3333"
          width="56"
          height="13.3333"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_103_2117" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_103_2117"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_103_2117"
          x="0"
          y="26.6667"
          width="56"
          height="13.3333"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_103_2117" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_103_2117"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  )
}

export const IndiaFlag = () => {
  return (
    <svg width="56" height="40" viewBox="0 0 56 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" y="0.5" width="55" height="39" rx="3.5" fill="white" stroke="#F5F5F5" />
      <mask
        id="mask0_103_850"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="56"
        height="40"
      >
        <rect x="0.5" y="0.5" width="55" height="39" rx="3.5" fill="white" stroke="white" />
      </mask>
      <g mask="url(#mask0_103_850)">
        <path fillRule="evenodd" clipRule="evenodd" d="M0 13.3333H56V0H0V13.3333Z" fill="#FFA44A" />
        <path fillRule="evenodd" clipRule="evenodd" d="M0 40H56V26.6666H0V40Z" fill="#1A9F0B" />
        <circle
          cx="28"
          cy="20"
          r="4.66667"
          fill="#181A93"
          fillOpacity="0.15"
          stroke="#181A93"
          strokeWidth="1.33333"
        />
        <circle cx="28" cy="20" r="1.33333" fill="#181A93" />
      </g>
    </svg>
  )
}

export const IndoneziaFlag = () => {
  return (
    <svg width="56" height="40" viewBox="0 0 56 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" y="0.5" width="55" height="39" rx="3.5" fill="white" stroke="#F5F5F5" />
      <mask
        id="mask0_103_822"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="56"
        height="40"
      >
        <rect x="0.5" y="0.5" width="55" height="39" rx="3.5" fill="white" stroke="white" />
      </mask>
      <g mask="url(#mask0_103_822)">
        <path fillRule="evenodd" clipRule="evenodd" d="M0 21.3333H56V0H0V21.3333Z" fill="#E12237" />
      </g>
    </svg>
  )
}

export const ItalyFlag = () => {
  return (
    <svg width="56" height="40" viewBox="0 0 56 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" y="0.5" width="55" height="39" rx="3.5" fill="white" stroke="#F5F5F5" />
      <mask
        id="mask0_103_81"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="56"
        height="40"
      >
        <rect x="0.5" y="0.5" width="55" height="39" rx="3.5" fill="white" stroke="white" />
      </mask>
      <g mask="url(#mask0_103_81)">
        <rect x="37.3333" width="18.6667" height="40" fill="#E43D4C" />
        <path fillRule="evenodd" clipRule="evenodd" d="M0 40H18.6667V0H0V40Z" fill="#1BB65D" />
      </g>
    </svg>
  )
}

export const MalaysiaFlag = () => {
  return (
    <svg width="56" height="40" viewBox="0 0 56 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="56" height="40" rx="4" fill="white" />
      <mask
        id="mask0_103_719"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="56"
        height="40"
      >
        <rect width="56" height="40" rx="4" fill="white" />
      </mask>
      <g mask="url(#mask0_103_719)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M56 0H26.6667V2.66667H56V0ZM56 5.33333H26.6667V8H56V5.33333ZM26.6667 10.6667H56V13.3333H26.6667V10.6667ZM56 16H26.6667V18.6667H56V16ZM0 21.3333H56V24H0V21.3333ZM56 26.6667H0V29.3333H56V26.6667ZM0 32H56V34.6667H0V32ZM56 37.3333H0V40H56V37.3333Z"
          fill="#E1244A"
        />
        <rect width="32" height="21.3333" fill="#0C3F8E" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16 4.00002C16.8195 4.00002 17.6045 4.14789 18.3297 4.4184C16.9607 3.32224 15.2236 2.66669 13.3334 2.66669C8.9151 2.66669 5.33337 6.24841 5.33337 10.6667C5.33337 15.085 8.9151 18.6667 13.3334 18.6667C15.2236 18.6667 16.9607 18.0111 18.3297 16.915C17.6045 17.1855 16.8195 17.3334 16 17.3334C12.3181 17.3334 9.33337 14.3486 9.33337 10.6667C9.33337 6.98479 12.3181 4.00002 16 4.00002ZM19.0193 15.4719L21.3334 12.8534L23.6474 15.4719L23.043 12.0301L26.533 11.8535L23.4652 10.1801L25.5031 7.34141L22.2821 8.69657L21.3334 5.33335L20.3846 8.69657L17.1636 7.34141L19.2015 10.1801L16.1338 11.8535L19.6238 12.0301L19.0193 15.4719Z"
          fill="#FFD34F"
        />
      </g>
    </svg>
  )
}

export const PortugalFlag = () => {
  return (
    <svg width="56" height="40" viewBox="0 0 56 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="56" height="40" rx="4" fill="white" />
      <mask
        id="mask0_103_1392"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="56"
        height="40"
      >
        <rect width="56" height="40" rx="4" fill="white" />
      </mask>
      <g mask="url(#mask0_103_1392)">
        <rect width="56" height="40" fill="#FF2936" />
        <path fillRule="evenodd" clipRule="evenodd" d="M0 40H21.3333V0H0V40Z" fill="#128415" />
        <circle cx="21.3333" cy="20" r="6.66667" stroke="#FAF94F" strokeWidth="2.66667" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.6667 16.6667C18.6667 16.2985 18.9652 16 19.3334 16H23.3334C23.7016 16 24.0001 16.2985 24.0001 16.6667V21.3333C24.0001 22.8061 22.8062 24 21.3334 24C19.8607 24 18.6667 22.8061 18.6667 21.3333V16.6667Z"
          fill="white"
        />
        <ellipse cx="21.3333" cy="19.3333" rx="1.33333" ry="2" fill="#1D50B5" />
      </g>
    </svg>
  )
}

export const SpainFlag = () => {
  return (
    <svg width="56" height="40" viewBox="0 0 56 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="56" height="40" rx="4" fill="white" />
      <mask
        id="mask0_103_323"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="56"
        height="40"
      >
        <rect width="56" height="40" rx="4" fill="white" />
      </mask>
      <g mask="url(#mask0_103_323)">
        <path fillRule="evenodd" clipRule="evenodd" d="M0 10.6667H56V0H0V10.6667Z" fill="#DD172C" />
        <path fillRule="evenodd" clipRule="evenodd" d="M0 40H56V29.3333H0V40Z" fill="#DD172C" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 29.3333H56V10.6667H0V29.3333Z"
          fill="#FFD133"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.6667 18.6667H17.3334V20H14.6667V18.6667Z"
          fill="#FFEDB1"
        />
        <path
          d="M12.1181 18.722C12.0857 18.3333 12.3924 18 12.7824 18H16.551C16.941 18 17.2477 18.3333 17.2153 18.722L16.8728 22.8328C16.7864 23.8693 15.9198 24.6667 14.8797 24.6667H14.4537C13.4135 24.6667 12.547 23.8693 12.4606 22.8328L12.1181 18.722Z"
          stroke="#A41517"
          strokeWidth="1.33333"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 20H17.3333V21.3333H16L14.6667 24L13.3333 21.3333H12V20Z"
          fill="#A41517"
        />
        <rect x="8" y="16" width="2.66667" height="9.33333" rx="1.33333" fill="#A41517" />
        <rect x="18.6667" y="16" width="2.66667" height="9.33333" rx="1.33333" fill="#A41517" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 15.4667C12 14.2885 12.9551 13.3333 14.1333 13.3333H15.2C16.3782 13.3333 17.3333 14.2885 17.3333 15.4667C17.3333 15.7612 17.0946 16 16.8 16H12.5333C12.2388 16 12 15.7612 12 15.4667Z"
          fill="#A41517"
        />
      </g>
    </svg>
  )
}

export const SwedenFlag = () => {
  return (
    <svg width="56" height="40" viewBox="0 0 56 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="56" height="40" rx="4" fill="white" />
      <mask
        id="mask0_103_790"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="56"
        height="40"
      >
        <rect width="56" height="40" rx="4" fill="white" />
      </mask>
      <g mask="url(#mask0_103_790)">
        <rect width="56" height="40" fill="#157CBB" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 24H16V40H24V24H56V16H24V0H16V16H0V24Z"
          fill="#FFD34D"
        />
      </g>
    </svg>
  )
}

export const ThailandFlag = () => {
  return (
    <svg width="56" height="40" viewBox="0 0 56 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" y="0.5" width="55" height="39" rx="3.5" fill="white" stroke="#F5F5F5" />
      <mask
        id="mask0_103_2"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="56"
        height="40"
      >
        <rect x="0.5" y="0.5" width="55" height="39" rx="3.5" fill="white" stroke="white" />
      </mask>
      <g mask="url(#mask0_103_2)">
        <path fillRule="evenodd" clipRule="evenodd" d="M0 8H56V0H0V8Z" fill="#F12532" />
        <path fillRule="evenodd" clipRule="evenodd" d="M0 40H56V32H0V40Z" fill="#F12532" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 26.6667H56V13.3334H0V26.6667Z"
          fill="#322B6C"
        />
      </g>
    </svg>
  )
}

export const TurkeyFlag = () => {
  return (
    <svg width="56" height="40" viewBox="0 0 56 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="56" height="40" rx="4" fill="white" />
      <mask
        id="mask0_103_131"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="56"
        height="40"
      >
        <rect width="56" height="40" rx="4" fill="white" />
      </mask>
      <g mask="url(#mask0_103_131)">
        <rect width="56" height="40" fill="#E92434" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M38.0418 21.5368L35.5922 24.5067L35.759 20.6605L32.1774 19.2485L35.887 18.2187L36.1231 14.376L38.2489 17.5858L41.9764 16.6229L39.5806 19.6365L41.6482 22.884L38.0418 21.5368Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M34.8054 12.6318C33.111 11.4002 30.9806 10.6667 28.6666 10.6667C23.1437 10.6667 18.6666 14.8453 18.6666 20C18.6666 25.1547 23.1437 29.3333 28.6666 29.3333C30.9806 29.3333 33.111 28.5998 34.8054 27.3682C32.6096 30.187 29.1832 32 25.3333 32C18.7058 32 13.3333 26.6274 13.3333 20C13.3333 13.3726 18.7058 8 25.3333 8C29.1832 8 32.6096 9.81299 34.8054 12.6318Z"
          fill="white"
        />
      </g>
    </svg>
  )
}

export const UKFlag = () => {
  return (
    <svg width="56" height="40" viewBox="0 0 56 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="56" height="40" rx="4" fill="white" />
      <mask
        id="mask0_103_1349"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="56"
        height="40"
      >
        <rect width="56" height="40" rx="4" fill="white" />
      </mask>
      <g mask="url(#mask0_103_1349)">
        <rect width="56" height="40" fill="#0A17A7" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M-2.565 -3.83289L21.3333 12.2867V-2.66666H34.6666V12.2867L58.5649 -3.83289L61.5472 0.588647L42.6525 13.3333H55.9999V26.6667H42.6525L61.5472 39.4114L58.5649 43.8329L34.6666 27.7133V42.6667H21.3333V27.7133L-2.565 43.8329L-5.54736 39.4114L13.3474 26.6667H-6.29425e-05V13.3333H13.3474L-5.54736 0.588648L-2.565 -3.83289Z"
          fill="white"
        />
        <path
          d="M37.3359 12.6644L62.6667 -4"
          stroke="#DB1F35"
          strokeWidth="1.33333"
          strokeLinecap="round"
        />
        <path
          d="M40.0256 27.395L62.7333 42.7007"
          stroke="#DB1F35"
          strokeWidth="1.33333"
          strokeLinecap="round"
        />
        <path
          d="M16.011 12.6209L-7.67505 -3.34198"
          stroke="#DB1F35"
          strokeWidth="1.33333"
          strokeLinecap="round"
        />
        <path
          d="M18.58 27.2098L-7.67505 44.6209"
          stroke="#DB1F35"
          strokeWidth="1.33333"
          strokeLinecap="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 24H24V40H32V24H56V16H32V0H24V16H0V24Z"
          fill="#E6273E"
        />
      </g>
    </svg>
  )
}

export const VietnamFlag = () => {
  return (
    <svg width="56" height="40" viewBox="0 0 56 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="56" height="40" rx="4" fill="white" />
      <mask
        id="mask0_103_1325"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="56"
        height="40"
      >
        <rect width="56" height="40" rx="4" fill="white" />
      </mask>
      <g mask="url(#mask0_103_1325)">
        <rect width="56" height="40" fill="#EA403F" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M28 24.68L20.9466 29.7082L23.5491 21.4462L16.5873 16.2918L25.2492 16.2138L28 8L30.7508 16.2138L39.4127 16.2918L32.4509 21.4462L35.0534 29.7082L28 24.68Z"
          fill="#FFFE4E"
        />
      </g>
    </svg>
  )
}

export const AfganistanFlag = () => {
  return (
    <svg width="56" height="40" viewBox="0 0 56 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="56" height="40" rx="4" fill="white" />
      <mask
        id="mask0_403_2325"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="56"
        height="40"
      >
        <rect width="56" height="40" rx="4" fill="white" />
      </mask>
      <g mask="url(#mask0_403_2325)">
        <rect x="26.6667" width="29.3333" height="40" fill="#1AB11F" />
        <path fillRule="evenodd" clipRule="evenodd" d="M0 40H18.6667V0H0V40Z" fill="#262626" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.6667 40H37.3333V0H18.6667V40Z"
          fill="#DC0D18"
        />
        <path
          opacity="0.75"
          d="M25.9964 22.1297L26.6655 20.9765L25.9964 22.1297ZM26.4805 23.9522L27.6337 24.6213L27.6337 24.6213L26.4805 23.9522ZM24.6581 24.4363L25.3272 23.283H25.3272L24.6581 24.4363ZM31.5881 24.2862L32.3065 25.4095L31.5881 24.2862ZM29.7464 23.8814L28.6232 24.5998H28.6232L29.7464 23.8814ZM30.1513 22.0397L30.8697 23.163L30.1513 22.0397ZM25.3333 18.6667C25.3333 17.1939 24.1394 16 22.6667 16V18.6667H25.3333ZM26.6655 20.9765C25.8638 20.5113 25.3333 19.6499 25.3333 18.6667H22.6667C22.6667 20.6375 23.7358 22.3596 25.3272 23.283L26.6655 20.9765ZM27.6337 24.6213C28.3729 23.3475 27.9394 21.7156 26.6655 20.9765L25.3272 23.283L25.3272 23.283L27.6337 24.6213ZM23.9889 25.5895C25.2627 26.3286 26.8946 25.8952 27.6337 24.6213L25.3272 23.283L23.9889 25.5895ZM20 18.6667C20 21.6278 21.6101 24.2092 23.9889 25.5895L25.3272 23.283C23.7361 22.3597 22.6667 20.6378 22.6667 18.6667H20ZM22.6667 16C21.1939 16 20 17.1939 20 18.6667H22.6667V16ZM36 18.6667C36 17.1939 34.8061 16 33.3333 16V18.6667H36ZM32.3065 25.4095C34.5215 23.9928 36 21.5035 36 18.6667H33.3333C33.3333 20.5554 32.3515 22.2152 30.8697 23.163L32.3065 25.4095ZM28.6232 24.5998C29.4167 25.8405 31.0658 26.203 32.3065 25.4095L30.8697 23.163V23.163L28.6232 24.5998ZM29.4329 20.9165C28.1922 21.71 27.8297 23.3591 28.6232 24.5998L30.8697 23.163L29.4329 20.9165ZM30.6667 18.6667C30.6667 19.6091 30.18 20.4387 29.4329 20.9165L30.8697 23.163C32.3518 22.2151 33.3333 20.5551 33.3333 18.6667H30.6667ZM33.3333 16C31.8606 16 30.6667 17.1939 30.6667 18.6667H33.3333V16Z"
          fill="white"
        />
        <ellipse cx="28" cy="17.3334" rx="2.66667" ry="4" fill="white" fillOpacity="0.5" />
      </g>
    </svg>
  )
}

export const ArgentinaFlag = () => {
  return (
    <svg width="56" height="40" viewBox="0 0 56 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" y="0.5" width="55" height="39" rx="3.5" fill="white" stroke="#F5F5F5" />
      <mask
        id="mask0_403_1739"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="56"
        height="40"
      >
        <rect x="0.5" y="0.5" width="55" height="39" rx="3.5" fill="white" stroke="white" />
      </mask>
      <g mask="url(#mask0_403_1739)">
        <path fillRule="evenodd" clipRule="evenodd" d="M0 13.3333H56V0H0V13.3333Z" fill="#88BBE8" />
        <path fillRule="evenodd" clipRule="evenodd" d="M0 40H56V26.6667H0V40Z" fill="#88BBE8" />
        <circle cx="28" cy="20" r="4.66667" fill="#F4B32E" stroke="#DB7A2C" strokeWidth="1.33333" />
      </g>
    </svg>
  )
}

export const AustraliaFlag = () => {
  return (
    <svg width="56" height="40" viewBox="0 0 56 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="56" height="40" rx="4" fill="white" />
      <mask
        id="mask0_403_550"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="56"
        height="40"
      >
        <rect width="56" height="40" rx="4" fill="white" />
      </mask>
      <g mask="url(#mask0_403_550)">
        <rect width="56" height="40" fill="#0A17A7" />
        <path
          d="M0 -0.666667H-1.80217L-0.433861 0.506171L8.66667 8.30662V10.3236L-0.387492 16.7908L-0.666667 16.9903V17.3333V18.6667V19.8695L0.353333 19.232L10.8579 12.6667H13.1197L22.1642 19.127C22.352 19.2612 22.5771 19.3333 22.808 19.3333C23.8363 19.3333 24.3096 18.054 23.5288 17.3847L15.3333 10.36V8.34308L24.1083 2.07523C24.4587 1.82495 24.6667 1.42086 24.6667 0.990254V0V-1.20283L23.6467 -0.565332L13.1421 6H10.8803L1.72083 -0.542489L1.54698 -0.666667H1.33333H0Z"
          fill="#FF2E3B"
          stroke="white"
          strokeWidth="1.33333"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 6.66667V12H9.33333V18.6667C9.33333 19.403 9.93029 20 10.6667 20H13.3333C14.0697 20 14.6667 19.403 14.6667 18.6667V12H24C24.7364 12 25.3333 11.403 25.3333 10.6667V8C25.3333 7.26362 24.7364 6.66667 24 6.66667H14.6667V0H9.33333V6.66667H0Z"
          fill="url(#paint0_linear_403_550)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 8H10.6667V6.66667V0H13.3333V6.66667V8H24V10.6667H13.3333V12V18.6667H10.6667V12V10.6667H0V8Z"
          fill="url(#paint1_linear_403_550)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 32.6667L9.64886 33.9028L10.0979 31.2847L8.19577 29.4306L10.8244 29.0487L12 26.6667L13.1756 29.0487L15.8042 29.4306L13.9021 31.2847L14.3511 33.9028L12 32.6667Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M40 34.6666L38.1144 35.2189L38.6667 33.3333L38.1144 31.4477L40 32L41.8856 31.4477L41.3333 33.3333L41.8856 35.2189L40 34.6666Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M40 9.33333L38.1144 9.88562L38.6667 8L38.1144 6.11438L40 6.66666L41.8856 6.11438L41.3333 8L41.8856 9.88562L40 9.33333Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M48 17.3333L46.1144 17.8856L46.6667 16L46.1144 14.1144L48 14.6667L49.8856 14.1144L49.3333 16L49.8856 17.8856L48 17.3333Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M32 20L30.1144 20.5523L30.6667 18.6667L30.1144 16.7811L32 17.3334L33.8856 16.7811L33.3333 18.6667L33.8856 20.5523L32 20Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M44 23.3334L43.0572 23.6095L43.3333 22.6667L43.0572 21.7239L44 22L44.9428 21.7239L44.6667 22.6667L44.9428 23.6095L44 23.3334Z"
          fill="white"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_403_550"
          x1="0"
          y1="0"
          x2="0"
          y2="20"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#F0F0F0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_403_550"
          x1="0"
          y1="0"
          x2="0"
          y2="18.6667"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF2E3B" />
          <stop offset="1" stopColor="#FC0D1B" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export const AzerbaijanFlag = () => {
  return (
    <svg width="56" height="40" viewBox="0 0 56 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="56" height="40" rx="4" fill="white" />
      <mask
        id="mask0_403_1712"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="56"
        height="40"
      >
        <rect width="56" height="40" rx="4" fill="white" />
      </mask>
      <g mask="url(#mask0_403_1712)">
        <path fillRule="evenodd" clipRule="evenodd" d="M0 13.3333H56V0H0V13.3333Z" fill="#24AAD5" />
        <path fillRule="evenodd" clipRule="evenodd" d="M0 40H56V26.6667H0V40Z" fill="#21BF75" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 26.6667H56V13.3333H0V26.6667Z"
          fill="#ED1845"
        />
        <g filter="url(#filter0_d_403_1712)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M30 16.6667C30.0749 16.6667 30.1492 16.6691 30.2229 16.674C29.5871 16.2483 28.8226 16 28 16C25.7909 16 24 17.7909 24 20C24 22.2091 25.7909 24 28 24C28.8226 24 29.5871 23.7517 30.2229 23.326C30.1492 23.3309 30.0749 23.3333 30 23.3333C28.1591 23.3333 26.6667 21.8409 26.6667 20C26.6667 18.1591 28.1591 16.6667 30 16.6667ZM30.6667 21.3333C31.403 21.3333 32 20.7364 32 20C32 19.2636 31.403 18.6667 30.6667 18.6667C29.9303 18.6667 29.3333 19.2636 29.3333 20C29.3333 20.7364 29.9303 21.3333 30.6667 21.3333Z"
            fill="white"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_d_403_1712"
          x="24"
          y="16"
          width="8"
          height="10"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_403_1712" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_403_1712"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  )
}

export const BrazilFlag = () => {
  return (
    <svg width="56" height="40" viewBox="0 0 56 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="56" height="40" rx="4" fill="white" />
      <mask
        id="mask0_403_2262"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="56"
        height="40"
      >
        <rect width="56" height="40" rx="4" fill="white" />
      </mask>
      <g mask="url(#mask0_403_2262)">
        <rect width="56" height="40" fill="#05AB41" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.06335 21.1194C6.25136 20.594 6.25135 19.406 7.06335 18.8805L27.2757 5.80199C27.7164 5.51679 28.2836 5.51679 28.7243 5.80199L48.9366 18.8805C49.7486 19.406 49.7486 20.594 48.9366 21.1194L28.7243 34.198C28.2836 34.4832 27.7164 34.4832 27.2757 34.198L7.06335 21.1194Z"
          fill="#FDD216"
        />
        <circle cx="28" cy="20" r="9.33333" fill="#053087" />
        <mask
          id="mask1_403_2262"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="18"
          y="10"
          width="20"
          height="20"
        >
          <circle cx="28" cy="20" r="9.33333" fill="white" />
        </mask>
        <g mask="url(#mask1_403_2262)">
          <path
            d="M17.5599 17.5605C19.0253 16.3739 23.754 17.498 28.1681 18.6755C32.5823 19.853 37.1861 22.321 38.3583 23.7686"
            stroke="white"
            strokeWidth="2.66667"
            strokeLinecap="square"
          />
        </g>
      </g>
    </svg>
  )
}

export const BulgariaFlag = () => {
  return (
    <svg width="56" height="40" viewBox="0 0 56 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" y="0.5" width="55" height="39" rx="3.5" fill="white" stroke="#F5F5F5" />
      <mask
        id="mask0_403_2252"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="56"
        height="40"
      >
        <rect x="0.5" y="0.5" width="55" height="39" rx="3.5" fill="white" stroke="white" />
      </mask>
      <g mask="url(#mask0_403_2252)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 26.6666H56V13.3333H0V26.6666Z"
          fill="#06A77C"
        />
        <path fillRule="evenodd" clipRule="evenodd" d="M0 40H56V26.6667H0V40Z" fill="#E32E19" />
      </g>
    </svg>
  )
}

export const GeorgiaFlag = () => {
  return (
    <svg width="56" height="40" viewBox="0 0 56 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" y="0.5" width="55" height="39" rx="3.5" fill="white" stroke="#F5F5F5" />
      <mask
        id="mask0_403_1149"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="56"
        height="40"
      >
        <rect x="0.5" y="0.5" width="55" height="39" rx="3.5" fill="white" stroke="white" />
      </mask>
      <g mask="url(#mask0_403_1149)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M32 42.6667H24V24H-2.66669V16H24V-2.66666H32V16H58.6666V24H32V42.6667Z"
          fill="#FF2B37"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M43.2 8.8L40 9.33333V6.66667L43.2 7.2L42.6667 4H45.3333L44.8 7.2L48 6.66667V9.33333L44.8 8.8L45.3333 12H42.6667L43.2 8.8Z"
          fill="#FD0D1B"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.2 8.8L8 9.33333V6.66667L11.2 7.2L10.6667 4H13.3333L12.8 7.2L16 6.66667V9.33333L12.8 8.8L13.3333 12H10.6667L11.2 8.8Z"
          fill="#FD0D1B"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.2 32.8L8 33.3333V30.6667L11.2 31.2L10.6667 28H13.3333L12.8 31.2L16 30.6667V33.3333L12.8 32.8L13.3333 36H10.6667L11.2 32.8Z"
          fill="#FD0D1B"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M43.2 32.8L40 33.3333V30.6667L43.2 31.2L42.6667 28H45.3333L44.8 31.2L48 30.6667V33.3333L44.8 32.8L45.3333 36H42.6667L43.2 32.8Z"
          fill="#FD0D1B"
        />
      </g>
    </svg>
  )
}

export const GreeceFlag = () => {
  return (
    <svg width="56" height="40" viewBox="0 0 56 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" y="0.5" width="55" height="39" rx="3.5" fill="white" stroke="#F5F5F5" />
      <mask
        id="mask0_403_1930"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="56"
        height="40"
      >
        <rect x="0.5" y="0.5" width="55" height="39" rx="3.5" fill="white" stroke="white" />
      </mask>
      <g mask="url(#mask0_403_1930)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.6667 0H0V10.6667H10.6667V0ZM26.6667 0H16V10.6667H26.6667L26.6667 16H16V26.6667H26.6667H56V21.3333H26.6667V16H56V10.6667H26.6667L26.6667 5.33333H56V0H26.6667ZM56 32H0V37.3333H56V32ZM10.6667 16H0V26.6667H10.6667V16Z"
          fill="#1C6DC1"
        />
      </g>
    </svg>
  )
}

export const LebanonFlag = () => {
  return (
    <svg width="56" height="40" viewBox="0 0 56 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" y="0.5" width="55" height="39" rx="3.5" fill="white" stroke="#F5F5F5" />
      <mask
        id="mask0_403_2246"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="56"
        height="40"
      >
        <rect x="0.5" y="0.5" width="55" height="39" rx="3.5" fill="white" stroke="white" />
      </mask>
      <g mask="url(#mask0_403_2246)">
        <path fillRule="evenodd" clipRule="evenodd" d="M0 10.6667H56V0H0V10.6667Z" fill="#F03340" />
        <path fillRule="evenodd" clipRule="evenodd" d="M0 40H56V29.3333H0V40Z" fill="#F03340" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M25.8856 24.781C26.317 24.3497 26.317 23.6503 25.8856 23.2189L25.7322 23.0655C25.4847 22.8181 25.1256 22.7186 24.7861 22.8035L24.0276 22.9931C23.1403 23.2149 22.5895 22.0579 23.3212 21.5091L24.0066 20.995C24.4316 20.6763 24.2062 20 23.675 20C23.0917 20 22.906 19.2136 23.4278 18.9528L24.5722 18.3805C25.094 18.1197 24.9083 17.3333 24.325 17.3333C23.7938 17.3333 23.5684 16.6571 23.9934 16.3383L27.2 13.9333C27.6741 13.5778 28.3259 13.5778 28.8 13.9333L32.0066 16.3383C32.4316 16.6571 32.2062 17.3333 31.675 17.3333C31.0917 17.3333 30.906 18.1197 31.4278 18.3805L32.5722 18.9528C33.094 19.2136 32.9083 20 32.325 20C31.7938 20 31.5684 20.6763 31.9934 20.995L32.6788 21.5091C33.4105 22.0579 32.8597 23.2149 31.9724 22.9931L31.2139 22.8035C30.8744 22.7186 30.5153 22.8181 30.2678 23.0655L30.1144 23.2189C29.683 23.6503 29.683 24.3497 30.1144 24.781C30.8102 25.4769 30.3174 26.6667 29.3333 26.6667H26.6667C25.6826 26.6667 25.1898 25.4769 25.8856 24.781Z"
          fill="#1FC065"
        />
      </g>
    </svg>
  )
}

export const MaltaFlag = () => {
  return (
    <svg width="56" height="40" viewBox="0 0 56 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" y="0.5" width="55" height="39" rx="3.5" fill="white" stroke="#F5F5F5" />
      <mask
        id="mask0_403_1922"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="56"
        height="40"
      >
        <rect x="0.5" y="0.5" width="55" height="39" rx="3.5" fill="white" stroke="white" />
      </mask>
      <g mask="url(#mask0_403_1922)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M29.3334 40H56V0H29.3334V40Z"
          fill="#DE233C"
        />
        <mask
          id="path-4-outside-1_403_1922"
          maskUnits="userSpaceOnUse"
          x="3.33337"
          y="3.33331"
          width="12"
          height="12"
          fill="black"
        >
          <rect fill="white" x="3.33337" y="3.33331" width="12" height="12" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.6667 5.33331H8.00004V7.99998H5.33337V10.6666H8.00004V13.3333H10.6667V10.6666H13.3334V7.99998H10.6667V5.33331Z"
          />
        </mask>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.6667 5.33331H8.00004V7.99998H5.33337V10.6666H8.00004V13.3333H10.6667V10.6666H13.3334V7.99998H10.6667V5.33331Z"
          fill="#CCCCCD"
        />
        <path
          d="M8.00004 5.33331V3.99998H6.66671V5.33331H8.00004ZM10.6667 5.33331H12V3.99998H10.6667V5.33331ZM8.00004 7.99998V9.33331H9.33337V7.99998H8.00004ZM5.33337 7.99998V6.66665H4.00004V7.99998H5.33337ZM5.33337 10.6666H4.00004V12H5.33337V10.6666ZM8.00004 10.6666H9.33337V9.33331H8.00004V10.6666ZM8.00004 13.3333H6.66671V14.6666H8.00004V13.3333ZM10.6667 13.3333V14.6666H12V13.3333H10.6667ZM10.6667 10.6666V9.33331H9.33337V10.6666H10.6667ZM13.3334 10.6666V12H14.6667V10.6666H13.3334ZM13.3334 7.99998H14.6667V6.66665H13.3334V7.99998ZM10.6667 7.99998H9.33337V9.33331H10.6667V7.99998ZM8.00004 6.66665H10.6667V3.99998H8.00004V6.66665ZM9.33337 7.99998V5.33331H6.66671V7.99998H9.33337ZM5.33337 9.33331H8.00004V6.66665H5.33337V9.33331ZM6.66671 10.6666V7.99998H4.00004V10.6666H6.66671ZM8.00004 9.33331H5.33337V12H8.00004V9.33331ZM9.33337 13.3333V10.6666H6.66671V13.3333H9.33337ZM10.6667 12H8.00004V14.6666H10.6667V12ZM9.33337 10.6666V13.3333H12V10.6666H9.33337ZM13.3334 9.33331H10.6667V12H13.3334V9.33331ZM12 7.99998V10.6666H14.6667V7.99998H12ZM10.6667 9.33331H13.3334V6.66665H10.6667V9.33331ZM9.33337 5.33331V7.99998H12V5.33331H9.33337Z"
          fill="#7B716A"
          fillOpacity="0.66"
          mask="url(#path-4-outside-1_403_1922)"
        />
        <circle cx="9.33333" cy="9.33333" r="1.33333" fill="#7B716A" />
      </g>
    </svg>
  )
}

export const NetherlandsFlag = () => {
  return (
    <svg width="56" height="40" viewBox="0 0 56 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" y="0.5" width="55" height="39" rx="3.5" fill="white" stroke="#F5F5F5" />
      <mask
        id="mask0_403_1185"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="56"
        height="40"
      >
        <rect x="0.5" y="0.5" width="55" height="39" rx="3.5" fill="white" stroke="white" />
      </mask>
      <g mask="url(#mask0_403_1185)">
        <path fillRule="evenodd" clipRule="evenodd" d="M0 13.3333H56V0H0V13.3333Z" fill="#CA2B39" />
        <path fillRule="evenodd" clipRule="evenodd" d="M0 40H56V26.6667H0V40Z" fill="#2C56A2" />
      </g>
    </svg>
  )
}

export const NewZealandFlag = () => {
  return (
    <svg width="56" height="40" viewBox="0 0 56 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="56" height="40" rx="4" fill="white" />
      <mask
        id="mask0_403_1174"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="56"
        height="40"
      >
        <rect width="56" height="40" rx="4" fill="white" />
      </mask>
      <g mask="url(#mask0_403_1174)">
        <rect width="56" height="40" fill="#0A17A7" />
        <path
          d="M0 -0.666667H-1.80217L-0.433861 0.506171L8.66667 8.30662V10.3236L-0.387492 16.7908L-0.666667 16.9903V17.3333V18.6667V19.8695L0.353333 19.232L10.8579 12.6667H13.1197L22.1642 19.127C22.352 19.2612 22.5771 19.3333 22.808 19.3333C23.8363 19.3333 24.3096 18.054 23.5288 17.3847L15.3333 10.36V8.34308L24.1083 2.07523C24.4587 1.82495 24.6667 1.42086 24.6667 0.990254V0V-1.20283L23.6467 -0.565332L13.1421 6H10.8803L1.72083 -0.542489L1.54698 -0.666667H1.33333H0Z"
          fill="#FF2E3B"
          stroke="white"
          strokeWidth="1.33333"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 6.66667V12H9.33333V18.6667C9.33333 19.403 9.93029 20 10.6667 20H13.3333C14.0697 20 14.6667 19.403 14.6667 18.6667V12H24C24.7364 12 25.3333 11.403 25.3333 10.6667V8C25.3333 7.26362 24.7364 6.66667 24 6.66667H14.6667V0H9.33333V6.66667H0Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 8H10.6667V6.66667V0H13.3333V6.66667V8H24V10.6667H13.3333V12V18.6667H10.6667V12V10.6667H0V8Z"
          fill="#FF2E3B"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M39.9999 34.6667L38.1143 35.219L38.6666 33.3334L38.1143 31.4477L39.9999 32L41.8855 31.4477L41.3333 33.3334L41.8855 35.219L39.9999 34.6667Z"
          fill="#CA1931"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M39.9999 9.33331L38.1143 9.8856L38.6666 7.99998L38.1143 6.11436L39.9999 6.66665L41.8855 6.11436L41.3333 7.99998L41.8855 9.8856L39.9999 9.33331Z"
          fill="#CA1931"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M47.9999 17.3333L46.1143 17.8856L46.6666 16L46.1143 14.1144L47.9999 14.6666L49.8855 14.1144L49.3333 16L49.8855 17.8856L47.9999 17.3333Z"
          fill="#CA1931"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M31.9999 20L30.1143 20.5523L30.6666 18.6667L30.1143 16.781L31.9999 17.3333L33.8855 16.781L33.3333 18.6667L33.8855 20.5523L31.9999 20Z"
          fill="#CA1931"
        />
      </g>
    </svg>
  )
}

export const NigeriaFlag = () => {
  return (
    <svg width="56" height="40" viewBox="0 0 56 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" y="0.5" width="55" height="39" rx="3.5" fill="white" stroke="#F5F5F5" />
      <mask
        id="mask0_403_2421"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="56"
        height="40"
      >
        <rect x="0.5" y="0.5" width="55" height="39" rx="3.5" fill="white" stroke="white" />
      </mask>
      <g mask="url(#mask0_403_2421)">
        <rect x="37.3333" width="18.6667" height="40" fill="#189B62" />
        <path fillRule="evenodd" clipRule="evenodd" d="M0 40H18.6667V0H0V40Z" fill="#189B62" />
      </g>
    </svg>
  )
}

export const KoreaFlag = () => {
  return (
    <svg width="56" height="40" viewBox="0 0 56 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" y="0.5" width="55" height="39" rx="3.5" fill="white" stroke="#F5F5F5" />
      <mask
        id="mask0_403_269"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="56"
        height="40"
      >
        <rect x="0.5" y="0.5" width="55" height="39" rx="3.5" fill="white" stroke="white" />
      </mask>
      <g mask="url(#mask0_403_269)">
        <circle cx="28.0001" cy="20" r="9.33333" fill="#E01B41" />
        <mask
          id="mask1_403_269"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="18"
          y="10"
          width="20"
          height="20"
        >
          <circle cx="28.0001" cy="20" r="9.33333" fill="white" />
        </mask>
        <g mask="url(#mask1_403_269)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18.6666 21.3333C21.3333 23.8333 25.3333 25.3333 28 21.3333C30.6666 17.3333 36 17.3333 37.3333 21.3333C38.6666 25.3333 37.3333 29.3333 37.3333 29.3333H18.6666C18.6666 29.3333 16 18.8333 18.6666 21.3333Z"
            fill="#0E4B9C"
          />
        </g>
        <path
          opacity="0.75"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.3461 7.11325C12.5302 6.79439 12.9379 6.68514 13.2568 6.86923L14.4115 7.5359C14.7303 7.71999 14.8396 8.12772 14.6555 8.44658L11.3222 14.2201C11.1381 14.5389 10.7303 14.6482 10.4115 14.4641L9.25679 13.7974C8.93792 13.6133 8.82867 13.2056 9.01277 12.8868L12.3461 7.11325ZM41.5884 7.5359C41.2695 7.71999 41.1603 8.12772 41.3444 8.44658L44.6777 14.2201C44.8618 14.5389 45.2695 14.6482 45.5884 14.4641L46.7431 13.7974C47.062 13.6133 47.1712 13.2056 46.9871 12.8868L43.6538 7.11325C43.4697 6.79439 43.062 6.68514 42.7431 6.86923L41.5884 7.5359ZM38.1243 9.5359C37.8054 9.71999 37.6962 10.1277 37.8803 10.4466L41.2136 16.2201C41.3977 16.5389 41.8054 16.6482 42.1243 16.4641L43.279 15.7974C43.5979 15.6133 43.7071 15.2056 43.523 14.8868L40.1897 9.11325C40.0056 8.79439 39.5979 8.68514 39.279 8.86923L38.1243 9.5359ZM9.01277 27.1132C8.82867 26.7944 8.93792 26.3867 9.25678 26.2026L10.4115 25.5359C10.7303 25.3518 11.1381 25.4611 11.3222 25.7799L14.6555 31.5534C14.8396 31.8723 14.7303 32.28 14.4115 32.4641L13.2568 33.1308C12.9379 33.3149 12.5302 33.2056 12.3461 32.8868L9.01277 27.1132ZM12.7209 24.2026C12.402 24.3867 12.2928 24.7944 12.4769 25.1132L15.8102 30.8868C15.9943 31.2056 16.402 31.3149 16.7209 31.1308L17.8756 30.4641C18.1944 30.28 18.3037 29.8723 18.1196 29.5534L14.7863 23.7799C14.6022 23.4611 14.1944 23.3518 13.8756 23.5359L12.7209 24.2026ZM41.2136 23.7799C41.3977 23.4611 41.8054 23.3518 42.1243 23.5359L43.279 24.2026C43.5979 24.3867 43.7071 24.7944 43.523 25.1133L40.1897 30.8868C40.0056 31.2056 39.5979 31.3149 39.279 31.1308L38.1243 30.4641C37.8054 30.28 37.6962 29.8723 37.8803 29.5534L41.2136 23.7799ZM45.5884 25.5359C45.2695 25.3518 44.8618 25.4611 44.6777 25.7799L41.3444 31.5534C41.1603 31.8723 41.2695 32.28 41.5884 32.4641L42.7431 33.1308C43.062 33.3149 43.4697 33.2056 43.6538 32.8868L46.9871 27.1133C47.1712 26.7944 47.062 26.3867 46.7431 26.2026L45.5884 25.5359ZM16.7209 8.86923C16.402 8.68514 15.9943 8.79439 15.8102 9.11325L12.4769 14.8868C12.2928 15.2056 12.402 15.6133 12.7209 15.7974L13.8756 16.4641C14.1944 16.6482 14.6022 16.5389 14.7863 16.2201L18.1196 10.4466C18.3037 10.1277 18.1944 9.71999 17.8756 9.5359L16.7209 8.86923Z"
          fill="#262626"
        />
      </g>
    </svg>
  )
}

export const ZimbabweFlag = () => {
  return (
    <svg width="56" height="40" viewBox="0 0 56 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="56" height="40" rx="1.71429" fill="white" />
      <mask
        id="mask0_403_1302"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="56"
        height="40"
      >
        <rect width="56" height="40" rx="1.71429" fill="white" />
      </mask>
      <g mask="url(#mask0_403_1302)">
        <path fillRule="evenodd" clipRule="evenodd" d="M0 5.33333H56V0H0V5.33333Z" fill="#369D0C" />
        <path fillRule="evenodd" clipRule="evenodd" d="M0 40H56V34.6667H0V40Z" fill="#369D0C" />
        <path fillRule="evenodd" clipRule="evenodd" d="M0 16H56V10.6667H0V16Z" fill="#369D0C" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 29.3333H56V24H0V29.3333Z"
          fill="#369D0C"
        />
        <path fillRule="evenodd" clipRule="evenodd" d="M0 24H56V16H0V24Z" fill="#262626" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 10.6667H56V5.33334H0V10.6667Z"
          fill="#FFD40E"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 34.6667H56V29.3333H0V34.6667Z"
          fill="#FFD40E"
        />
        <path
          d="M-2.09532 39.4286V0.571429H-0.190557L25.7142 20L-0.190559 39.4286H-2.09532Z"
          fill="white"
          stroke="#262626"
          strokeWidth="1.14286"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.99992 22.6L4.08135 25.3934L5.52717 20.8034L1.65954 17.9399L6.47168 17.8966L7.99992 13.3333L9.52816 17.8966L14.3403 17.9399L10.4727 20.8034L11.9185 25.3934L7.99992 22.6Z"
          fill="url(#paint0_linear_403_1302)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_403_1302"
          x1="1.33325"
          y1="13.3333"
          x2="1.33325"
          y2="26.6667"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F12F1F" />
          <stop offset="1" stopColor="#DE2010" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export const PakistanFlag = () => {
  return (
    <svg width="56" height="40" viewBox="0 0 56 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" y="0.5" width="55" height="39" rx="3.5" fill="white" stroke="#F5F5F5" />
      <mask
        id="mask0_403_1991"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="56"
        height="40"
      >
        <rect x="0.5" y="0.5" width="55" height="39" rx="3.5" fill="white" stroke="white" />
      </mask>
      <g mask="url(#mask0_403_1991)">
        <path fillRule="evenodd" clipRule="evenodd" d="M56 0H16V40H56V0Z" fill="#0A632F" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M47.3403 21.5011C47.0836 24.0024 46.0175 26.4058 44.1331 28.2902C39.6414 32.7819 32.2011 32.6242 27.5148 27.9379C22.8285 23.2516 22.6708 15.8114 27.1625 11.3197C29.047 9.43521 31.4504 8.36912 33.9517 8.11245C33.1638 8.57677 32.418 9.14971 31.7372 9.83056C27.6538 13.914 27.4518 20.3325 31.2861 24.1667C35.1203 28.0009 41.5388 27.799 45.6222 23.7156C46.303 23.0347 46.876 22.289 47.3403 21.5011ZM42.1849 16.2094L41.5485 20.0063L39.7698 16.5919L35.9621 17.1599L38.6598 14.4132L36.9429 10.9674L40.3888 12.6842L43.1354 9.98657L42.5674 13.7943L45.9818 15.5729L42.1849 16.2094Z"
          fill="white"
        />
      </g>
    </svg>
  )
}

export const PolandFlag = () => {
  return (
    <svg width="56" height="40" viewBox="0 0 56 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" y="0.5" width="55" height="39" rx="3.5" fill="white" stroke="#F5F5F5" />
      <mask
        id="mask0_403_1055"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="56"
        height="40"
      >
        <rect x="0.5" y="0.5" width="55" height="39" rx="3.5" fill="white" stroke="white" />
      </mask>
      <g mask="url(#mask0_403_1055)">
        <path fillRule="evenodd" clipRule="evenodd" d="M0 40H56V18.6667H0V40Z" fill="#EB2A50" />
      </g>
    </svg>
  )
}

export const RomaniaFlag = () => {
  return (
    <svg width="56" height="40" viewBox="0 0 56 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="56" height="40" rx="4" fill="white" />
      <mask
        id="mask0_403_1035"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="56"
        height="40"
      >
        <rect width="56" height="40" rx="4" fill="white" />
      </mask>
      <g mask="url(#mask0_403_1035)">
        <rect x="26.6667" width="29.3333" height="40" fill="#E5253D" />
        <path fillRule="evenodd" clipRule="evenodd" d="M0 40H18.6667V0H0V40Z" fill="#0A3D9C" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.6667 40H37.3334V0H18.6667V40Z"
          fill="#FFD955"
        />
      </g>
    </svg>
  )
}

export const SamoaFlag = () => {
  return (
    <svg width="56" height="40" viewBox="0 0 56 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="56" height="40" rx="4" fill="white" />
      <mask
        id="mask0_403_970"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="56"
        height="40"
      >
        <rect width="56" height="40" rx="4" fill="white" />
      </mask>
      <g mask="url(#mask0_403_970)">
        <rect width="56" height="40" fill="#E31F37" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M-2.66675 21.3333H29.3333V-2.66669H-2.66675V21.3333Z"
          fill="#083B9A"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.3335 5.33333L11.4478 5.88562L12.0001 4L11.4478 2.11438L13.3335 2.66666L15.2191 2.11438L14.6668 4L15.2191 5.88562L13.3335 5.33333ZM13.3335 18.6667L11.4478 19.219L12.0001 17.3333L11.4478 15.4477L13.3335 16L15.2191 15.4477L14.6668 17.3333L15.2191 19.219L13.3335 18.6667ZM6.1145 12.5523L8.00012 12L9.88574 12.5523L9.33345 10.6667L9.88574 8.78105L8.00012 9.33333L6.1145 8.78105L6.66679 10.6667L6.1145 12.5523ZM20.0001 10.6667L18.1145 11.2189L18.6668 9.33333L18.1145 7.44771L20.0001 8L21.8857 7.44771L21.3335 9.33333L21.8857 11.2189L20.0001 10.6667ZM16.6668 14.6667C17.035 14.6667 17.3335 14.3682 17.3335 14C17.3335 13.6318 17.035 13.3333 16.6668 13.3333C16.2986 13.3333 16.0001 13.6318 16.0001 14C16.0001 14.3682 16.2986 14.6667 16.6668 14.6667Z"
          fill="white"
        />
      </g>
    </svg>
  )
}

export const SerbiaFlag = () => {
  return (
    <svg width="56" height="40" viewBox="0 0 56 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" y="0.5" width="55" height="39" rx="3.5" fill="white" stroke="#F5F5F5" />
      <mask
        id="mask0_403_477"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="56"
        height="40"
      >
        <rect x="0.5" y="0.5" width="55" height="39" rx="3.5" fill="white" stroke="white" />
      </mask>
      <g mask="url(#mask0_403_477)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 26.6666H56V13.3333H0V26.6666Z"
          fill="#17508F"
        />
        <path fillRule="evenodd" clipRule="evenodd" d="M0 13.3333H56V0H0V13.3333Z" fill="#E1444D" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 20C12 18.7099 12.6873 15.8357 13.075 14.3171C13.2236 13.735 13.7499 13.3333 14.3507 13.3333H20.3184C20.918 13.3333 21.4436 13.7334 21.5928 14.3142C21.9807 15.8239 22.6667 18.6804 22.6667 20C22.6667 21.4899 21.6661 25.4015 21.3985 26.4209C21.3554 26.5848 21.2823 26.7353 21.1744 26.866C20.6634 27.4851 18.9984 29.3333 17.3333 29.3333C15.6673 29.3333 14.0012 27.4828 13.4913 26.8649C13.384 26.7349 13.3112 26.5854 13.2681 26.4225C13.0004 25.4104 12 21.5269 12 20Z"
          fill="white"
        />
        <mask
          id="mask1_403_477"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="12"
          y="13"
          width="11"
          height="17"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 20C12 18.7099 12.6873 15.8357 13.075 14.3171C13.2236 13.735 13.7499 13.3333 14.3507 13.3333H20.3184C20.918 13.3333 21.4436 13.7334 21.5928 14.3142C21.9807 15.8239 22.6667 18.6804 22.6667 20C22.6667 21.4899 21.6661 25.4015 21.3985 26.4209C21.3554 26.5848 21.2823 26.7353 21.1744 26.866C20.6634 27.4851 18.9984 29.3333 17.3333 29.3333C15.6673 29.3333 14.0012 27.4828 13.4913 26.8649C13.384 26.7349 13.3112 26.5854 13.2681 26.4225C13.0004 25.4104 12 21.5269 12 20Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask1_403_477)">
          <path
            d="M22.6667 14.6666L12.0001 28"
            stroke="#E1444D"
            strokeWidth="2.66667"
            strokeLinecap="square"
          />
          <path
            d="M12 14.6666L22.6667 28"
            stroke="#E1444D"
            strokeWidth="2.66667"
            strokeLinecap="square"
          />
        </g>
      </g>
    </svg>
  )
}

export const USAFlag = () => {
  return (
    <svg width="56" height="40" viewBox="0 0 56 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="56" height="40" rx="4" fill="white" />
      <mask
        id="mask0_403_17"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="56"
        height="40"
      >
        <rect width="56" height="40" rx="4" fill="white" />
      </mask>
      <g mask="url(#mask0_403_17)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M56 0H0V2.66667H56V0ZM56 5.33333H0V8H56V5.33333ZM0 10.6667H56V13.3333H0V10.6667ZM56 16H0V18.6667H56V16ZM0 21.3333H56V24H0V21.3333ZM56 26.6667H0V29.3333H56V26.6667ZM0 32H56V34.6667H0V32ZM56 37.3333H0V40H56V37.3333Z"
          fill="#D02F44"
        />
        <rect width="24" height="18.6667" fill="#46467F" />
        <g filter="url(#filter0_d_403_17)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.00008 5.33335C4.73646 5.33335 5.33341 4.7364 5.33341 4.00002C5.33341 3.26364 4.73646 2.66669 4.00008 2.66669C3.2637 2.66669 2.66675 3.26364 2.66675 4.00002C2.66675 4.7364 3.2637 5.33335 4.00008 5.33335ZM9.33342 5.33335C10.0698 5.33335 10.6667 4.7364 10.6667 4.00002C10.6667 3.26364 10.0698 2.66669 9.33342 2.66669C8.59704 2.66669 8.00008 3.26364 8.00008 4.00002C8.00008 4.7364 8.59704 5.33335 9.33342 5.33335ZM16.0001 4.00002C16.0001 4.7364 15.4031 5.33335 14.6667 5.33335C13.9304 5.33335 13.3334 4.7364 13.3334 4.00002C13.3334 3.26364 13.9304 2.66669 14.6667 2.66669C15.4031 2.66669 16.0001 3.26364 16.0001 4.00002ZM20.0001 5.33335C20.7365 5.33335 21.3334 4.7364 21.3334 4.00002C21.3334 3.26364 20.7365 2.66669 20.0001 2.66669C19.2637 2.66669 18.6667 3.26364 18.6667 4.00002C18.6667 4.7364 19.2637 5.33335 20.0001 5.33335ZM8.00008 6.66669C8.00008 7.40307 7.40313 8.00002 6.66675 8.00002C5.93037 8.00002 5.33341 7.40307 5.33341 6.66669C5.33341 5.93031 5.93037 5.33335 6.66675 5.33335C7.40313 5.33335 8.00008 5.93031 8.00008 6.66669ZM12.0001 8.00002C12.7365 8.00002 13.3334 7.40307 13.3334 6.66669C13.3334 5.93031 12.7365 5.33335 12.0001 5.33335C11.2637 5.33335 10.6667 5.93031 10.6667 6.66669C10.6667 7.40307 11.2637 8.00002 12.0001 8.00002ZM18.6667 6.66669C18.6667 7.40307 18.0698 8.00002 17.3334 8.00002C16.597 8.00002 16.0001 7.40307 16.0001 6.66669C16.0001 5.93031 16.597 5.33335 17.3334 5.33335C18.0698 5.33335 18.6667 5.93031 18.6667 6.66669ZM20.0001 10.6667C20.7365 10.6667 21.3334 10.0697 21.3334 9.33335C21.3334 8.59697 20.7365 8.00002 20.0001 8.00002C19.2637 8.00002 18.6667 8.59697 18.6667 9.33335C18.6667 10.0697 19.2637 10.6667 20.0001 10.6667ZM16.0001 9.33335C16.0001 10.0697 15.4031 10.6667 14.6667 10.6667C13.9304 10.6667 13.3334 10.0697 13.3334 9.33335C13.3334 8.59697 13.9304 8.00002 14.6667 8.00002C15.4031 8.00002 16.0001 8.59697 16.0001 9.33335ZM9.33342 10.6667C10.0698 10.6667 10.6667 10.0697 10.6667 9.33335C10.6667 8.59697 10.0698 8.00002 9.33342 8.00002C8.59704 8.00002 8.00008 8.59697 8.00008 9.33335C8.00008 10.0697 8.59704 10.6667 9.33342 10.6667ZM5.33341 9.33335C5.33341 10.0697 4.73646 10.6667 4.00008 10.6667C3.2637 10.6667 2.66675 10.0697 2.66675 9.33335C2.66675 8.59697 3.2637 8.00002 4.00008 8.00002C4.73646 8.00002 5.33341 8.59697 5.33341 9.33335ZM6.66675 13.3334C7.40313 13.3334 8.00008 12.7364 8.00008 12C8.00008 11.2636 7.40313 10.6667 6.66675 10.6667C5.93037 10.6667 5.33341 11.2636 5.33341 12C5.33341 12.7364 5.93037 13.3334 6.66675 13.3334ZM13.3334 12C13.3334 12.7364 12.7365 13.3334 12.0001 13.3334C11.2637 13.3334 10.6667 12.7364 10.6667 12C10.6667 11.2636 11.2637 10.6667 12.0001 10.6667C12.7365 10.6667 13.3334 11.2636 13.3334 12ZM17.3334 13.3334C18.0698 13.3334 18.6667 12.7364 18.6667 12C18.6667 11.2636 18.0698 10.6667 17.3334 10.6667C16.597 10.6667 16.0001 11.2636 16.0001 12C16.0001 12.7364 16.597 13.3334 17.3334 13.3334ZM21.3334 14.6667C21.3334 15.4031 20.7365 16 20.0001 16C19.2637 16 18.6667 15.4031 18.6667 14.6667C18.6667 13.9303 19.2637 13.3334 20.0001 13.3334C20.7365 13.3334 21.3334 13.9303 21.3334 14.6667ZM14.6667 16C15.4031 16 16.0001 15.4031 16.0001 14.6667C16.0001 13.9303 15.4031 13.3334 14.6667 13.3334C13.9304 13.3334 13.3334 13.9303 13.3334 14.6667C13.3334 15.4031 13.9304 16 14.6667 16ZM10.6667 14.6667C10.6667 15.4031 10.0698 16 9.33342 16C8.59704 16 8.00008 15.4031 8.00008 14.6667C8.00008 13.9303 8.59704 13.3334 9.33342 13.3334C10.0698 13.3334 10.6667 13.9303 10.6667 14.6667ZM4.00008 16C4.73646 16 5.33341 15.4031 5.33341 14.6667C5.33341 13.9303 4.73646 13.3334 4.00008 13.3334C3.2637 13.3334 2.66675 13.9303 2.66675 14.6667C2.66675 15.4031 3.2637 16 4.00008 16Z"
            fill="url(#paint0_linear_403_17)"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_d_403_17"
          x="2.66675"
          y="2.66669"
          width="18.6667"
          height="15.3333"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_403_17" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_403_17"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_403_17"
          x1="2.66675"
          y1="2.66669"
          x2="2.66675"
          y2="16"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#F0F0F0" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export const CzechFlag = () => {
  return (
    <svg width="56" height="40" viewBox="0 0 56 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" y="0.5" width="55" height="39" rx="3.5" fill="white" stroke="#F5F5F5" />
      <mask
        id="mask0_403_2028"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="56"
        height="40"
      >
        <rect x="0.5" y="0.5" width="55" height="39" rx="3.5" fill="white" stroke="white" />
      </mask>
      <g mask="url(#mask0_403_2028)">
        <path fillRule="evenodd" clipRule="evenodd" d="M0 40H56V18.6666H0V40Z" fill="#E8252A" />
        <path fillRule="evenodd" clipRule="evenodd" d="M0 0L26.6667 20L0 40V0Z" fill="#17579E" />
      </g>
    </svg>
  )
}

export const JamaicaFlag = () => {
  return (
    <svg width="56" height="40" viewBox="0 0 56 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="56" height="40" rx="4" fill="white" />
      <mask
        id="mask0_403_144"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="56"
        height="40"
      >
        <rect width="56" height="40" rx="4" fill="white" />
      </mask>
      <g mask="url(#mask0_403_144)">
        <rect width="56" height="40" fill="#1DBE4F" />
        <path fillRule="evenodd" clipRule="evenodd" d="M0 0L24 20L0 40V0Z" fill="#262626" />
        <path fillRule="evenodd" clipRule="evenodd" d="M56 0L32 20L56 40V0Z" fill="#262626" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M28.0001 16.7834L-2.56488 -3.83289L-5.54724 0.588648L23.2313 20L-5.54724 39.4114L-2.56488 43.8329L28.0001 23.2166L58.565 43.8329L61.5474 39.4114L32.7688 20L61.5474 0.588647L58.565 -3.83289L28.0001 16.7834Z"
          fill="#FFD646"
        />
      </g>
    </svg>
  )
}

export const ScotlandFlag = () => {
  return (
    <svg width="56" height="40" viewBox="0 0 56 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="56" height="40" rx="4" fill="white" />
      <mask
        id="mask0_408_2437"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="56"
        height="40"
      >
        <rect width="56" height="40" rx="4" fill="white" />
      </mask>
      <g mask="url(#mask0_408_2437)">
        <rect width="56" height="40" fill="#005EB8" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M27.9999 16.7834L-2.565 -3.83289L-5.54736 0.588648L23.2312 20L-5.54736 39.4114L-2.565 43.8329L27.9999 23.2166L58.5649 43.8329L61.5472 39.4114L32.7687 20L61.5472 0.588647L58.5649 -3.83289L27.9999 16.7834Z"
          fill="white"
        />
      </g>
    </svg>
  )
}

export const FijiFlag = () => {
  return (
    <svg width="56" height="40" viewBox="0 0 56 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="56" height="40" rx="4" fill="white" />
      <mask
        id="mask0_403_494"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="56"
        height="40"
      >
        <rect width="56" height="40" rx="4" fill="white" />
      </mask>
      <g mask="url(#mask0_403_494)">
        <rect width="56" height="40" fill="#79CFF6" />
        <rect width="24" height="18.6667" fill="url(#paint0_linear_403_494)" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M34.6667 20C34.6667 16 34.6667 10.6667 34.6667 10.6667H48C48 10.6667 48 16 48 20C48 26.6667 41.3334 29.3333 41.3334 29.3333C41.3334 29.3333 34.6667 26.6667 34.6667 20Z"
          fill="white"
        />
        <mask
          id="mask1_403_494"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="34"
          y="10"
          width="14"
          height="20"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M34.6667 20C34.6667 16 34.6667 10.6667 34.6667 10.6667H48C48 10.6667 48 16 48 20C48 26.6667 41.3334 29.3333 41.3334 29.3333C41.3334 29.3333 34.6667 26.6667 34.6667 20Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask1_403_494)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M37.3333 17.3333C38.0697 17.3333 38.6667 16.7364 38.6667 16C38.6667 15.2636 38.0697 14.6667 37.3333 14.6667C36.597 14.6667 36 15.2636 36 16C36 16.7364 36.597 17.3333 37.3333 17.3333ZM45.3333 17.3333C46.0697 17.3333 46.6667 16.7364 46.6667 16C46.6667 15.2636 46.0697 14.6667 45.3333 14.6667C44.597 14.6667 44 15.2636 44 16C44 16.7364 44.597 17.3333 45.3333 17.3333Z"
            fill="#2A915C"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M34.6667 10.6667H48V13.3333H42.6667V18.6667H48V21.3333H42.6667V29.3333H40V21.3333H34.6667V18.6667H40V13.3333H34.6667V10.6667Z"
            fill="#EB1D43"
          />
        </g>
        <path
          d="M0 -0.666667H-1.80217L-0.433861 0.506171L8.66667 8.30662V10.3236L-0.387492 16.7908L-0.666667 16.9903V17.3333V18.6667V19.8695L0.353333 19.232L10.8579 12.6667H13.1197L22.1642 19.127C22.352 19.2612 22.5771 19.3333 22.808 19.3333C23.8363 19.3333 24.3096 18.054 23.5288 17.3847L15.3333 10.36V8.34308L24.1083 2.07523C24.4587 1.82495 24.6667 1.42086 24.6667 0.990254V0V-1.20283L23.6467 -0.565332L13.1421 6H10.8803L1.72083 -0.542489L1.54698 -0.666667H1.33333H0Z"
          fill="#DB1E36"
          stroke="white"
          strokeWidth="1.33333"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 6.66667V12H9.33333V18.6667C9.33333 19.403 9.93029 20 10.6667 20H13.3333C14.0697 20 14.6667 19.403 14.6667 18.6667V12H24C24.7364 12 25.3333 11.403 25.3333 10.6667V8C25.3333 7.26362 24.7364 6.66667 24 6.66667H14.6667V0H9.33333V6.66667H0Z"
          fill="url(#paint1_linear_403_494)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 8H10.6667V6.66667V0H13.3333V6.66667V8H24V10.6667H13.3333V12V18.6667H10.6667V12V10.6667H0V8Z"
          fill="#DB1E36"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_403_494"
          x1="0"
          y1="0"
          x2="0"
          y2="18.6667"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#042C90" />
          <stop offset="1" stopColor="#00247E" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_403_494"
          x1="0"
          y1="0"
          x2="0"
          y2="20"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#F0F0F0" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export const FinlandFlag = () => {
  return (
    <svg width="56" height="40" viewBox="0 0 56 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" y="0.5" width="55" height="39" rx="3.5" fill="white" stroke="#F5F5F5" />
      <mask
        id="mask0_403_460"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="56"
        height="40"
      >
        <rect x="0.5" y="0.5" width="55" height="39" rx="3.5" fill="white" stroke="white" />
      </mask>
      <g mask="url(#mask0_403_460)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M-2.66669 24H16V42.6667H24V24H58.6666V16H24V-2.66667H16V16H-2.66669V24Z"
          fill="#0848A6"
        />
      </g>
    </svg>
  )
}

export const SouthAfricaFlag = () => {
  return (
    <svg width="56" height="40" viewBox="0 0 56 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="56" height="40" rx="4" fill="#06A86E" />
      <mask
        id="mask0_403_82"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="56"
        height="40"
      >
        <rect width="56" height="40" rx="4" fill="white" />
      </mask>
      <g mask="url(#mask0_403_82)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 5.33333L18.6667 20L0 34.6667V5.33333Z"
          fill="#FFBF2E"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M-2.66675 6L15.3333 20L-2.66675 34V6Z"
          fill="#262626"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M23.9999 16L5.33325 0H55.9999V16H23.9999Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M24.6667 13.3333L8.66675 0H56.0001V13.3333H24.6667Z"
          fill="#F44E46"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.33325 40H55.9999V24H23.9999L5.33325 40Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.66675 40H56.0001V26.6667H24.6667L8.66675 40Z"
          fill="#072CB4"
        />
      </g>
    </svg>
  )
}